import styled from 'styled-components';

const Main = styled.div`
  padding: 0px 32px;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-top: 40px;
  height: 79px;
  padding: 20px;
  background-color: ${({ theme }) => theme.COLOR_BG_LIGHT};
`;

const categoriesAddEditFormStyle = {
  ButtonContainer,
  Main,
};

export default categoriesAddEditFormStyle;
